module.exports = __webpack_public_path__ + "img/capacitor-magenta.361bc148.webp";